import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/play-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = ["onClick"]

import { // api
		getSceneSongScoresByRecordId
	} from '../../../../queries'

	import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'

	import {
		store as _userStore
	} from '@/store/user'
	
	import { // vue
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'SceneSoundSongInstruments' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		showDetails:{
			type: Function,
			default: () => {return}
		},
		song: {
			type: Object,
			default: () => {return {}}
		},
		previous: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()
	const userStore = _userStore()

	const {t} = useI18n()

	const instrumentsList = ref()
	const loading = ref(true)

	onMounted(async () => {
		try{ // fetching instruments by song record id
			loading.value = true
			const recordId = props.song.recordId

			const scriptParams = JSON.stringify({
				language: _localesStore.getFmLanguage,
				contactId: userStore.user.contactId
			})

			const params = `?script.prerequest=${encodeURI("Set Language")}&script.prerequest.param=${encodeURI(scriptParams)}`
		
			let res = await getSceneSongScoresByRecordId(recordId, params)
			const record = res.response.data[0]
			
			instrumentsList.value = record.portalData.jobs_scongs_scores__INSTRUMENT_JOBS__jobsSongsScoresID
		}
		catch(e) {
			console.log(e)
		}
		finally{
			loading.value = false
			
		}
	})

	function hasScore(row: any) {
		return row?.['jobs_scongs_scores__instrument_jobs__INSTRUMENTS__instrumentsID::s3JSONscoreSONG'] ||
			row?.['jobs_scongs_scores__instrument_jobs__INSTRUMENTS__instrumentsID::s3JSONscorePDF'] ||
			row?.['jobs_scongs_scores__instrument_jobs__INSTRUMENTS__instrumentsID::s3JSONkaraokeM4A']
	}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(__props.previous, 'songScore', null, null, 1))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToScores")), 1)
        ])
      ])
    ]),
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noSongs'),
      data: instrumentsList.value,
      loading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('149'),
          prop: "jobs_scongs_scores__instrument_jobs__ROLES__roleID::name_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('190'),
          prop: "jobs_scongs_scores__instrument_jobs__INSTRUMENTS__instrumentsID::description_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              onClick: ($event: any) => (__props.showDetails(row, 'songInstrumentFiles', null, __props.song)),
              class: "h-6 w-6 cursor-pointer"
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([ hasScore(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_0,
                alt: "View files"
              }, null, 2)
            ], 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ], 64))
}
}

})